export default {"src":"/_next/static/media/firebase.20c6dcf8.svg","height":351,"width":256,"blurWidth":0,"blurHeight":0};